{
  "background": {
    "primary": "#1b2628",
    "secondary": "#141d1f",
    "brand": {
      "primary": "#55dcf6",
      "secondary": "#135d6c"
    },
    "brandExtra": {
      "primary": "#9580ff",
      "secondary": "#301b98"
    },
    "inverse": "#ffffff",
    "static": {
      "dark": "#000000",
      "light": "#ffffff"
    },
    "success": {
      "primary": "#95ff80",
      "secondary": "#1f301c"
    },
    "warning": {
      "primary": "#ffc380",
      "secondary": "#6c4313"
    },
    "alert": {
      "primary": "#e84f30",
      "secondary": "#6c2213"
    },
    "neutral": {
      "primary": "#99aeb2",
      "secondary": "#34474b"
    }
  },
  "content": {
    "primary": "#e8eced",
    "secondary": "rgba(255, 255, 255, 0.72)",
    "tertiary": "rgba(255, 255, 255, 0.5)",
    "brand": {
      "primary": "#31cae8",
      "secondary": "#55dcf6"
    },
    "brandExtra": {
      "primary": "#7055f6",
      "secondary": "#9580ff"
    },
    "inverse": "#000000",
    "static": {
      "light": "#ffffff",
      "dark": "#000000"
    },
    "success": {
      "primary": "#70f655",
      "secondary": "#3dc322"
    },
    "warning": {
      "primary": "#f6ab55",
      "secondary": "#c37822"
    },
    "alert": {
      "primary": "#f67055",
      "secondary": "#e84f30"
    },
    "neutral": {
      "primary": "#99aeb2",
      "secondary": "#4a6368"
    },
    "on": {
      "brand": "#000000",
      "brandExtra": "#ffffff",
      "success": "#000000",
      "warning": "#000000",
      "alert": "#ffffff",
      "neutral": "#000000"
    }
  },
  "border": {
    "primary": "#ffffff",
    "secondary": "rgba(127, 169, 178, 0.3)",
    "brand": "#31cae8",
    "brandExtra": "#9580ff",
    "inverse": "rgba(0, 0, 0, 0.14)",
    "success": "#3dc322",
    "warning": "#c37822",
    "alert": "#c33d22",
    "neutral": "#607f85"
  },
  "overlay": {
    "mono": "rgba(178, 242, 255, 0.06)",
    "brand": "rgba(128, 234, 255, 0.2)",
    "brandExtra": "rgba(149, 128, 255, 0.3)",
    "success": "rgba(149, 255, 128, 0.2)",
    "warning": "rgba(255, 195, 128, 0.24)",
    "alert": "rgba(255, 149, 128, 0.32)",
    "neutral": "rgba(123, 152, 157, 0.28)",
    "monoHover": "rgba(178, 242, 255, 0.12)"
  },
  "layer": {
    "scrim": "rgba(0, 0, 0, 0.45)",
    "float": "rgba(0, 0, 0, 0.75)"
  },
  "control": {
    "brand": {
      "primary": {
        "bg": "#80eaff",
        "bgHover": "#b2f2ff",
        "bgPress": "#55dcf6",
        "bgDisable": "rgba(52, 71, 75, 0.85)",
        "border": "#31cae8",
        "borderHover": "#55dcf6",
        "borderPress": "rgba(255, 255, 255, 0)",
        "borderDisable": "rgba(255, 255, 255, 0)"
      },
      "secondary": {
        "bg": "#135d6c",
        "bgHover": "#1b8398",
        "bgPress": "#0b3841",
        "border": "#22a8c3",
        "borderHover": "#22a8c3",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "tertiary": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "#0b3841",
        "bgPress": "#135d6c",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "text": {
        "primary": "#000000",
        "secondary": "#80eaff",
        "tertiary": "#80eaff",
        "disable": "rgba(232, 236, 237, 0.2)",
        "ghost": "#80eaff"
      },
      "ghost": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(128, 234, 255, 0.04)",
        "bgPress": "rgba(128, 234, 255, 0.08)",
        "border": "rgba(128, 234, 255, 0.16)",
        "borderHover": "rgba(128, 234, 255, 0.24)",
        "borderPress": "rgba(128, 234, 255, 0.16)"
      }
    },
    "mono": {
      "primary": {
        "bg": "#ffffff",
        "bgHover": "#e8eced",
        "bgPress": "#f4f5f6",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "secondary": {
        "bg": "#34474b",
        "bgHover": "#4a6368",
        "bgPress": "#233134",
        "border": "#4a6368",
        "borderHover": "#607f85",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "tertiary": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "#233134",
        "bgPress": "#34474b",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "text": {
        "primary": "#000000",
        "secondary": "#ffffff",
        "tertiary": "#ffffff",
        "ghost": "#ffffff"
      },
      "ghost": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(255, 255, 255, 0.04)",
        "bgPress": "rgba(255, 255, 255, 0.08)",
        "border": "rgba(255, 255, 255, 0.16)",
        "borderHover": "rgba(255, 255, 255, 0.24)",
        "borderPress": "rgba(255, 255, 255, 0.16)"
      }
    },
    "brandExtra": {
      "primary": {
        "bg": "#7055f6",
        "bgHover": "#5031e8",
        "bgPress": "#9580ff",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "secondary": {
        "bg": "#22136c",
        "bgHover": "#301b98",
        "bgPress": "#140b41",
        "border": "#7055f6",
        "borderHover": "#9580ff",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "tertiary": {
        "bg": "rgba(80, 49, 232, 0)",
        "bgHover": "rgba(149, 128, 255, 0.07)",
        "bgPress": "rgba(80, 49, 232, 0.12)",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "text": {
        "primary": "#ffffff",
        "secondary": "#ffffff",
        "tertiary": "#9580ff",
        "ghost": "#cef655"
      },
      "ghost": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(206, 246, 85, 0.04)",
        "bgPress": "rgba(206, 246, 85, 0.08)",
        "border": "rgba(206, 246, 85, 0.16)",
        "borderHover": "rgba(206, 246, 85, 0.24)",
        "borderPress": "rgba(206, 246, 85, 0.16)"
      }
    },
    "alert": {
      "bg": "#6c2213",
      "border": "#f67055",
      "primary": {
        "bg": "#f67055",
        "bgHover": "#ff9580",
        "bgPress": "#e84f30",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "secondary": {
        "bg": "#6c2213",
        "bgHover": "#98301b",
        "bgPress": "#41140b",
        "border": "#98301b",
        "borderHover": "#c33d22",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "tertiary": {
        "bg": "rgba(232, 79, 48, 0)",
        "bgHover": "rgba(246, 112, 85, 0.07)",
        "bgPress": "rgba(246, 112, 85, 0.12)",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "text": {
        "primary": "#ffffff",
        "secondary": "#ffffff",
        "tertiary": "#f67055",
        "ghost": "#f67055"
      },
      "ghost": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(246, 112, 85, 0.04)",
        "bgPress": "rgba(246, 112, 85, 0.08)",
        "border": "rgba(246, 112, 85, 0.16)",
        "borderHover": "rgba(246, 112, 85, 0.24)",
        "borderPress": "rgba(246, 112, 85, 0.16)"
      }
    },
    "input": {
      "bg": "rgba(178, 242, 255, 0.1)",
      "bgHover": "rgba(178, 242, 255, 0.15)",
      "bgDisable": "rgba(178, 242, 255, 0.25)",
      "border": "rgba(178, 242, 255, 0.1)",
      "borderHover": "rgba(178, 242, 255, 0.15)",
      "borderDisable": "rgba(255, 255, 255, 0)",
      "text": "#ffffff",
      "placeholder": "rgba(255, 255, 255, 0.56)",
      "textDisable": "rgba(255, 255, 255, 0.36)"
    },
    "focus": {
      "bg": "rgba(0, 0, 0, 0.8)",
      "border": "#31cae8"
    },
    "check": {
      "bg": "#135d6c",
      "bgHover": "#1b8398",
      "bgDisable": "rgba(178, 242, 255, 0.25)",
      "border": "#22a8c3",
      "borderHover": "#22a8c3",
      "borderDisable": "rgba(255, 255, 255, 0)",
      "icon": "#80eaff"
    },
    "faint": {
      "bg": "rgba(178, 242, 255, 0.15)",
      "bgHover": "rgba(178, 242, 255, 0.2)",
      "border": "rgba(178, 242, 255, 0.1)",
      "borderHover": "rgba(178, 242, 255, 0.15)"
    },
    "slider": {
      "bg": "#80eaff",
      "bgHover": "#b2f2ff",
      "bgDisable": "#34474b"
    },
    "switch": {
      "bg": "#135d6c",
      "bgHover": "#1b8398",
      "bgDisable": "rgba(178, 242, 255, 0.25)",
      "border": "#22a8c3",
      "borderHover": "#22a8c3",
      "borderDisable": "rgba(255, 255, 255, 0)"
    },
    "knob": {
      "bg": "#80eaff",
      "bgHover": "#b2f2ff",
      "bgActive": "#80eaff",
      "bgActiveHover": "#b2f2ff",
      "bgInactive": "#ffffff",
      "bgInactiveHover": "#f4f5f6",
      "bgDisable": "#34474b"
    },
    "text": {
      "primary": "#ffffff",
      "disable": "rgba(255, 255, 255, 0.4)"
    },
    "link": {
      "primary": "#55dcf6",
      "primaryHover": "#80eaff",
      "secondary": "#9580ff",
      "secondaryHover": "#bfb2ff"
    },
    "segmented": {
      "bg": "rgba(178, 242, 255, 0.1)",
      "bgHover": "rgba(178, 242, 255, 0.1)",
      "bgActive": "rgba(178, 242, 255, 0.15)",
      "border": "rgba(178, 242, 255, 0.1)",
      "borderHover": "rgba(178, 242, 255, 0.1)",
      "borderActive": "rgba(255, 255, 255, 0)",
      "text": "#ffffff",
      "textDisable": "rgba(255, 255, 255, 0.4)"
    },
    "tagLabel": {
      "product": {
        "bg": "#d9ff66",
        "text": "#000000",
        "textCompact": "rgba(255, 255, 255, 0.48)"
      },
      "rarity": {
        "bg": "#141d1f",
        "text": "#22a8c3"
      },
      "name": {
        "bg": "#233134",
        "text": "#b7c5c8"
      },
      "account": {
        "bg": "#9580ff",
        "text": "#000000",
        "textCompact": "rgba(255, 255, 255, 0.48)"
      },
      "id": {
        "bg": "#34474b",
        "bgSeries": "#000000",
        "textSeries": "#b7c5c8",
        "textNumber": "#b7c5c8",
        "textCompact": "rgba(255, 255, 255, 0.48)"
      },
      "subentity": {
        "bg": "#607f85",
        "text": "#000000"
      },
      "item": {
        "bg": "#80eaff",
        "text": "#000000",
        "textCompact": "rgba(255, 255, 255, 0.48)"
      }
    },
    "toast": {
      "bg": "#34474b"
    },
    "toggleButton": {
      "bg": "rgba(178, 242, 255, 0.1)",
      "bgHover": "rgba(178, 242, 255, 0.15)",
      "bgActive": "#135d6c",
      "bgDisable": "rgba(178, 242, 255, 0.25)",
      "border": "rgba(178, 242, 255, 0.1)",
      "borderHover": "rgba(178, 242, 255, 0.15)",
      "borderActive": "#22a8c3",
      "borderDisable": "rgba(255, 255, 255, 0)",
      "text": "#ffffff",
      "textActive": "#80eaff",
      "textDisable": "rgba(255, 255, 255, 0.36)"
    },
    "appButton": {
      "bg": "#34474b",
      "bgHover": "#4b6368",
      "bgPress": "#607f85",
      "border": "#4b6368",
      "borderHover": "#607f85",
      "borderPress": "rgba(255, 255, 255, 0)",
      "text": "#b7c5c8",
      "textDisable": "rgba(232, 236, 237, 0.2)"
    }
  }
}
